"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeologicalSurvey = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var SpaceBonus_1 = require("../../SpaceBonus");
var SpaceType_1 = require("../../SpaceType");
var Resources_1 = require("../../Resources");
var GainResources_1 = require("../../deferredActions/GainResources");
var Phase_1 = require("../../Phase");
var PartyName_1 = require("../../turmoil/parties/PartyName");
var PartyHooks_1 = require("../../turmoil/parties/PartyHooks");
var TurmoilPolicy_1 = require("../../turmoil/TurmoilPolicy");
var Tags_1 = require("../Tags");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var BoardType_1 = require("../../boards/BoardType");
var GeologicalSurvey = (function (_super) {
    __extends(GeologicalSurvey, _super);
    function GeologicalSurvey() {
        return _super.call(this, {
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.GEOLOGICAL_SURVEY,
            tags: [Tags_1.Tags.SCIENCE],
            cost: 8,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.greeneries(5).any().max(); }),
            metadata: {
                cardNumber: 'A09',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.effect('When placing a tile grants you any steel, titanium, or heat, you gain one additional of each of those resources that you gain.', function (eb) {
                        eb.emptyTile().startEffect;
                        eb.plus().steel(1).titanium(1).heat(1);
                    });
                }),
                description: 'Requires 5 or fewer greeneries on Mars.',
            },
        }) || this;
    }
    GeologicalSurvey.prototype.anyAdjacentSpaceGivesBonus = function (player, space, bonus) {
        return player.game.board.getAdjacentSpaces(space).some(function (adj) { var _a; return (_a = adj.adjacency) === null || _a === void 0 ? void 0 : _a.bonus.includes(bonus); });
    };
    GeologicalSurvey.prototype.onTilePlaced = function (cardOwner, activePlayer, space, boardType) {
        var _this = this;
        if (boardType !== BoardType_1.BoardType.MARS) {
            return;
        }
        if (cardOwner.game.phase === Phase_1.Phase.SOLAR || cardOwner.id !== activePlayer.id) {
            return;
        }
        [[Resources_1.Resources.STEEL, SpaceBonus_1.SpaceBonus.STEEL], [Resources_1.Resources.TITANIUM, SpaceBonus_1.SpaceBonus.TITANIUM], [Resources_1.Resources.HEAT, SpaceBonus_1.SpaceBonus.HEAT]].forEach(function (_a) {
            var resource = _a[0], bonus = _a[1];
            if ((resource === Resources_1.Resources.STEEL && space.spaceType !== SpaceType_1.SpaceType.COLONY && PartyHooks_1.PartyHooks.shouldApplyPolicy(cardOwner.game, PartyName_1.PartyName.MARS, TurmoilPolicy_1.TurmoilPolicy.MARS_FIRST_DEFAULT_POLICY)) ||
                space.bonus.includes(bonus) ||
                _this.anyAdjacentSpaceGivesBonus(cardOwner, space, bonus)) {
                cardOwner.game.defer(new GainResources_1.GainResources(cardOwner, resource, {
                    cb: function () { return activePlayer.game.log('${0} gained a bonus ${1} because of ${2}', function (b) { return b.player(cardOwner).string(resource).cardName(_this.name); }); },
                }));
            }
        });
    };
    GeologicalSurvey.prototype.play = function () {
        return undefined;
    };
    return GeologicalSurvey;
}(Card_1.Card));
exports.GeologicalSurvey = GeologicalSurvey;
//# sourceMappingURL=GeologicalSurvey.js.map